import styled from '@emotion/styled';

import { IconExclamationCircled } from 'components/icons/exclamationCircled';

export const Wrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 16,
}));

export const Label = styled.div((props) => ({
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const StyledExclamationCircledIcon = styled(IconExclamationCircled)((props) => ({
  color: props.theme.colors.inactive,
}));

export const StyledTooltip = styled.div((props) => ({
  display: 'flex',
  padding: 5,
  maxWidth: 400,
  border: `1px solid ${props.theme.colors.container.tertiary}`,
  borderRadius: 5,
  marginLeft: -15,
  marginBottom: 15,
  backgroundColor: props.theme.colors.background,
  boxShadow: '0px 3px 12px 0px rgba(41, 27, 79, 0.05)',
  fontSize: 12,
  fontWeight: 400,
  color: props.theme.colors.primary,
  fontFamily: props.theme.fonts.primary,
}));
